/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import {
  // eslint-disable-next-line max-len
  setCookie, setRallyClose, deleteCookie, serverDate, getPeriod, uuid,
} from '../../utils/common';

import { errorMessage } from '../../utils/message';
import api from '../../utils/api';

const checkAll = document.getElementById('ch_checkbox_all');
const checkboxGroup = document.querySelector('.checkbox_group');
const allCheckboxes = checkboxGroup ? checkboxGroup.querySelectorAll('input.ag_input') : [];

// 체크박스 전체 선택
if (checkAll) {
  checkAll.addEventListener('click', () => {
    const isChecked = checkAll.checked;
    allCheckboxes.forEach((checkbox) => {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = isChecked;
    });
  });
}

// 개별 체크박스 클릭 시 동작
allCheckboxes.forEach((checkbox) => {
  checkbox.addEventListener('click', () => {
    const allChecked = Array.from(allCheckboxes).every((cb) => cb.checked);
    checkAll.checked = allChecked;
  });
});

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const mainData = await api.mainLoad(); // 비동기 응답 기다리기
    setCookie('rallyGnbDate', mainData, 1);
    setRallyClose(mainData); // 이제 rallyClose에 올바른 데이터가 세팅됨
  } catch (error) {
    console.error('mainLoad 실패:', error);
  }
});

// 동의사항 체크 유무 확인
function checkAgreementStatus() {
  const agreementStatus = Array.from({ length: 5 }, (_, i) => {
    const el = document.getElementById(`ch_checkbox_${i + 1}`);
    return el && el.checked ? 'Y' : 'N';
  });

  const allMandatoryAgreementsChecked = agreementStatus.slice(0, 4).every((status) => status === 'Y');
  if (!allMandatoryAgreementsChecked) {
    alert(errorMessage.agree);
    return null;
  }

  return {
    agr1: agreementStatus[0],
    agr2: agreementStatus[1],
    agr3: agreementStatus[2],
    agr4: agreementStatus[3],
    agr5: agreementStatus[4],
  };
}

// 이전 버튼 이벤트
export function preAction() {
  deleteCookie('agree_json_data');
  const baseMbsUrl = 'www.chuncheonmarathon.com';
  const hostchosun = window.location.hostname === baseMbsUrl ? 'https://www.chosun.com' : 'https://sandbox.chosun.com';
  location.href = `${hostchosun}/test/chuncheonmarathon`;
}

// 다음 버튼 이벤트
export function nextAction() {
  const full = getPeriod('full', 'early');
  const ten = getPeriod('ten', 'early');

  // eslint-disable-next-line max-len
  if (!(serverDate() >= full.open && serverDate() <= full.close) && !(serverDate() >= ten.open && serverDate() <= ten.close)) {
    // eslint-disable-next-line no-alert
    alert(errorMessage.apply.finish.apply);
    return;
  }

  const agreementData = checkAgreementStatus();
  if (!agreementData) return;

  setCookie('agree_json_data', agreementData, 1);

  if (uuid) {
    location.href = `../apply/part-apply-early.html?uuid=${uuid}`;
  } else {
    alert('잘못된 접근입니다.');
    location.href = 'https://www.chosun.com/earlybird/chuncheonmarathon/';
  }
}

window.preAction = preAction;
window.nextAction = nextAction;
